module.exports = __webpack_public_path__ + "static/media/R10.8f00c8bd.jpg";